export const getTotalAmount = (shoppingCart) => {
  let totalAmount = 0;
  shoppingCart.forEach((product) => {
    totalAmount += product.totalOrder;
  });
  return totalAmount;
};

export const getTipTotalAmount = (totalAmount, tipPercentageOption) => {
  return totalAmount * (tipPercentageOption / 100);
};

export const getVersion = () => {
  return process.env.REACT_APP_VERSION;
};

export const getUserInactivityLimit = () => {
  const userInactivityLimit = process.env.REACT_APP_USER_INACTIVITY_LIMIT;
  if (userInactivityLimit) {
    return parseInt(userInactivityLimit, 10);
  }
  return 60000;
};

export const getUserInactivitySubLimit = () => {
  const userInactivitySubLimit = process.env.REACT_APP_USER_INACTIVITY_SUB_LIMIT;
  if (userInactivitySubLimit) {
    return parseInt(userInactivitySubLimit, 10);
  }
  return 10000;
}

export const formatDate = (dateString) => {
  if (!dateString) {
    return '--/--/---- --:--';
  }
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

export const buildVaucher = (data) => {
  const {
    id,
    uuid,
    start_at: startAt,
    end_at: endAt,
    balance,
    company: {
      fantasy_name: fantasyName,
      fiscal_number: fiscalNumber,
    },
    branch_office: {
      street,
      street_number: streetNumber,
    },
  } = data;

  const startAtFormatted = formatDate(startAt);
  const endAtFormatted = formatDate(endAt);
  const balanceObject = JSON.parse(balance);
  const { movements, tips } = balanceObject;

  const PAYMENTS_TYPES = {
    'credit': 'CREDITO',
    'debit': 'DEBITO',
    'cash': 'EFECTIVO',
  };

  let totalAmountMovements = 0;

  // Función para alinear texto en columnas
  const alignColumns = (label, quantity, amount) => {
    const labelPad = label.padEnd(15, ' ');
    const quantityPad = String(quantity).padStart(10, ' ');
    const amountPad = String(amount).padStart(17, ' ');
    return `${labelPad}${quantityPad}${amountPad}`;
  };

  // Función para alinear montos a la derecha
  const alignAmount = (label, amount) => {
    return `${label}${String(amount).padStart(42 - label.length, ' ')}`;
  };

  // Constantes para líneas separadoras y cabeceras
  const SEPARATOR_LINE = '-------------------------------------------';
  const HEADER_LINE = 'Movimiento       Cantidad             Monto';

  const movementsItems = movements.map((item) => {
    const { type, quantity = 0, amount } = item;
    const paymentType = PAYMENTS_TYPES[type];
    totalAmountMovements += amount;
    return alignColumns(paymentType, quantity, amount);
  });

  let totalAmountTips = 0;

  const tipsItems = tips.map((item) => {
    const { type, amount } = item;
    const paymentType = PAYMENTS_TYPES[type];
    totalAmountTips += amount;
    return alignAmount(`PROPINA ${paymentType}`, amount);
  });

  const voucher = [
    'toliv',
    'RESUMEN DE CIERRE',
    fiscalNumber,
    fantasyName,
    `${street} ${streetNumber}`,
    `Fecha apertura: ${startAtFormatted}`,
    `Fecha  cierre: ${endAtFormatted}`,
    `Numero de cierre: ${id}`,
    `Codaut cierre: ${uuid}`,
    'Resumen de ventas',
    '',
    HEADER_LINE,
    ...movementsItems,
    SEPARATOR_LINE,
    alignAmount('Total ventas', totalAmountMovements),
    'Propinas',
    ...tipsItems,
    SEPARATOR_LINE,
    alignAmount('Total propinas', totalAmountTips),
    'Resumen adquirencia por fecha',
    '',
    'Fecha         Forma Pago         Total',
    SEPARATOR_LINE,
    alignAmount('Total recaudado', totalAmountMovements + totalAmountTips)
  ];
  return voucher;
}